module.exports = __webpack_public_path__ + "img/Weapon_200.c87dd2fe.png";